import { render, staticRenderFns } from "./OwalSplitviewLayout.vue?vue&type=template&id=7bd876ea&scoped=true"
import script from "./OwalSplitviewLayout.vue?vue&type=script&lang=js"
export * from "./OwalSplitviewLayout.vue?vue&type=script&lang=js"
import style0 from "./OwalSplitviewLayout.vue?vue&type=style&index=0&id=7bd876ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd876ea",
  null
  
)

export default component.exports